import React, { Fragment } from 'react';
import Container from '../../../../constants/Container';
import { formatMoney_2 } from '../../../../helpers/DateFormat';

interface AdvVoucherRptProps {
  onAdvVoucherReport: any
}
const AdvancedVoucherListView: React.FC<AdvVoucherRptProps> = ({ onAdvVoucherReport }) => {
  const totalPartiCredit: number = onAdvVoucherReport?.results?.filter((item: any) => item?.glid !== 8)?.reduce(
    (sum: number, item: any) => sum + (item.particularcreditamt ? item.particularcreditamt : 0),
    0
  );

  const totalPartiDredit: number = onAdvVoucherReport?.results?.filter((item: any) => item?.glid !== 8)?.reduce(
    (sum: number, item: any) => sum + (item.particulardebitamt ? item.particulardebitamt : 0),
    0
  );

  const anotherCreditAmt: number = onAdvVoucherReport?.results?.filter((item: any) => item?.glid !== 8)?.reduce(
    (sum: number, item: any) => sum + (item.creditamt ? item.creditamt : 0),
    0
  );

  const anotherDebitAmt: number = onAdvVoucherReport?.results?.filter((item: any) => item?.glid !== 8)?.reduce(
    (sum: number, item: any) => sum + (item.debitamt ? item.debitamt : 0),
    0
  );

  return (
    <Fragment>
      <Container>
        <div className='overflow-x-auto overflow-y-auto h-[80vh]'>
          <table className='w-full'>
            <thead className='font-public-sans text-[12px] text-slate900 bg-slate-50 z-50 sticky top-0'>
              <tr>
                <th rowSpan={2} className='border border-slate300 py-1 w-10'>SN</th>
                <th rowSpan={2} className='border border-slate300 py-1'>Particulars</th>
                <th rowSpan={2} className='border border-slate300 py-1'>GLID</th>
                <th colSpan={2} className='border border-slate300 py-1'>Particular Amount</th>
                <th colSpan={2} className='border border-slate300 py-1'>Total Amount</th>
              </tr>
              <tr>
                <th className='border border-slate300 py-1'>Debit Amount</th>
                <th className='border border-slate300 py-1'>Credit Amount</th>
                <th className='border border-slate300 py-1'>Debit Amount</th>
                <th className='border border-slate300 py-1'>Credit Amount</th>
              </tr>
            </thead>
            <tbody>
              {
                onAdvVoucherReport?.results?.map((voucher: any, index: number) => (
                  <tr key={index} className='font-public-sans cursor-pointer hover:bg-slate100 text-[12px] text-slate900 py-1'>
                    <td align='center' className='border border-slate300 px-2 py-1'>{index + 1}.</td>
                    <td className='border border-slate300 px-2 py-1'>

                      <div className='flex justify-between'>
                        <div>
                          <span className='font-bold'>{voucher?.glname}</span> <span className='pl-8'>{voucher?.sub_ledg_name}</span><span className='pl-8'>{voucher?.particular_name}</span> </div>
                        <div>
                          <span className='pl-8'>{voucher?.subamt ? formatMoney_2(voucher?.subamt || "") : ""}</span>
                        </div>
                      </div></td>

                    <td align='center' className='border border-slate300 px-2 py-1'>{voucher.glid}</td>
                    <td align='right' className='border border-slate300 px-2 py-1'>{formatMoney_2(voucher.particulardebitamt || "0")}</td>
                    <td align='right' className='border border-slate300 px-2 py-1'>{formatMoney_2(voucher.particularcreditamt || "0")}</td>
                    <td align='right' className='border border-slate300 px-2 py-1'>{formatMoney_2(voucher.debitamt || "0")}</td>
                    <td align='right' className='border border-slate300 px-2 py-1'>{formatMoney_2(voucher.creditamt || "0")}</td>
                  </tr>
                ))
              }
              <tr className='font-public-sans bg-slate100 font-bold text-[12px] text-slate900 py-1'>
                <td align='right' colSpan={2} className='border border-slate300 px-2 py-1'>Total Amount</td>
                <td align='right' className='border font-bold border-slate300 px-2 py-1'></td>
                <td align='right' className='border border-slate300 px-2 py-1'>{formatMoney_2(Math.abs(totalPartiDredit))}</td>
                <td align='right' className='border border-slate300 px-2 py-1'>{formatMoney_2(Math.abs(totalPartiCredit))}</td>
                <td align='right' className='border border-slate300 px-2 py-1'>{formatMoney_2(Math.abs(anotherDebitAmt))}</td>
                <td align='right' className='border border-slate300 px-2 py-1'>{formatMoney_2(Math.abs(anotherCreditAmt))}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </Fragment>
  )
}

export default AdvancedVoucherListView
